import { api } from "../AxiosInstance";

// Define service functions for general data related API calls
const MetaDataService = {
  getContainerSizes: async () => {
    try {
      const response = await api.get("/master/container-sizes");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getContainerTypes: async () => {
    try {
      const response = await api.get("/master/container-types");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getJobCycles: async () => {
    try {
      const response = await api.get("/master/job-cycles");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getJobTypes: async () => {
    try {
      const response = await api.get("/master/job-types");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getJobStatuses: async () => {
    try {
      const response = await api.get("/master/job-statuses");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getOrgTypes: async () => {
    try {
      const response = await api.get("/master/org-types");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getTrailerCapacities: async () => {
    try {
      const response = await api.get("/master/trailer-capacities");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },

  getTripStatuses: async () => {
    try {
      const response = await api.get("/master/trip-statuses");
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error;
    }
  },
};

export default MetaDataService;
